export const getItemsQueryString = (items: string[]) => {
  if (items.length === 0) {
    return null;
  }
  return `items=${items.toString()}`;
};
